import React from 'react';
// @mui
import { Grid } from '@mui/material';
// components
import RTextField from '../../componentes/forms/inputs/RTextField';
import RSelect from '../../componentes/forms/inputs/RSelect';

// ----------------------------------------------------------------------

export default function BusqForm({ showLoader, actualizaCampo, busqueda, provincias, tipos, oficinas }) {
  React.useEffect(() => {
    showLoader(false);
    // eslint-disable-next-line
  },[]);

  return (
    <form style={{ width: '100%'}}>
      <Grid container spacing={1} sx={{ marginBottom: '30px' }}>
        <RSelect name="oficina" label="Oficina*" actualizaCampo={actualizaCampo} value={busqueda.oficina} md={3}
          values={oficinas}
        />
        <RTextField type="text" name="texto" label="Texto*" actualizaCampo={actualizaCampo} value={busqueda.texto} md={6} />
        <RSelect name="provincia" label="Provincia*" actualizaCampo={actualizaCampo} value={busqueda.provincia} md={3}
          values={provincias}
        />
      </Grid>
      <Grid container spacing={1}>
          {/* <RSelect name="tipo" label="Tipo Busqueda" actualizaCampo={actualizaCampo} value={busqueda.tipo} md={3}
          values={tipos}
        /> */}
        <RTextField type="text" name="notas" label="Anotación" actualizaCampo={actualizaCampo} value={busqueda.notas} md={4} />
      </Grid>
    </form>
  );
}
